import { Dot, Props } from "./LoadingIcon.Parts";

export const LoadingIcon = (props: Props) => (
  <svg
    viewBox="0 0 41 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Dot fill="currentColor" cx="4" cy="4" r="4" $delay={0} />
    <Dot fill="currentColor" cx="20" cy="4" r="4" $delay={0.2} />
    <Dot fill="currentColor" cx="36" cy="4" r="4" $delay={0.4} />
  </svg>
);
